import React from "react";
import { useUboCountryRisk } from "../../../hooks/useUboCountryRisk";
import { Input } from "../../ui/Input";
import { RadioGroup } from "../../ui/RadioGroup";
import { SelectRegulatoryBody } from "../../selectors/regulatoryBody/selectRegulatoryBody";
import { SelectCountry } from "../../selectors/country/selectCountry";
import { Select } from "../../ui/Select";
import { yesNoOption } from "../../options/options";
export const FundForm = React.memo(({renderBy, index, formData, onChange, isReadOnly, isReport}) => {
    const handleCountryChange = useUboCountryRisk(renderBy + index + "Fund", onChange);
    return (
        <>
            <Input
                label={"Name of Fund"}
                name={"uboFundName"}
                value={formData.uboFundName}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />
<SelectCountry
                label={"Country of Registration"}
                name={"uboCountry"}
                value={formData.uboCountry}
                onChange={handleCountryChange}
                disabled={isReadOnly}
                isReport={isReport}
                required
            />
            <RadioGroup
                label={"Is this a Regulated Fund?"}
                name={"uboRegulatedFund"}
                value={formData.uboRegulatedFund}
                onChange={onChange}
                disabled={isReadOnly}
                options={yesNoOption}
                isReport={isReport}
                required
            />

            {
                formData.uboRegulatedFund === "Yes" &&
                <Input 
                    label={"Regulatory reference number"}
                    name={"uboRegulatoryReferenceNumber"}
                    value={formData.uboRegulatoryReferenceNumber}
                    onChange={onChange}
                    disabled={isReadOnly}
                    isReport={isReport}
                />
            }

            <Select 
                label={"Type of Fund"}
                name={"uboFundType"}
                value={formData.uboFundType}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
                options={[
                    { value: "Institutional", display_value: "Institutional" },
                    { value: "Private", display_value: "Private" },
                    { value: "Mutual fund", display_value: "Mutual fund" },
                    { value: "Index fund", display_value: "Index fund" },
                    { value: "Income fund", display_value: "Income fund" },
                    { value: "Commodity fund", display_value: "Commodity fund" },
                    { value: "Trust fund", display_value: "Trust fund" },
                    { value: "Capital Protection fund", display_value: "Capital Protection fund" },
                    { value: "Balanced fund", display_value: "Balanced fund" },
                    { value: "Equity fund", display_value: "Equity fund" },
                    { value: "Bond", display_value: "Bond" },
                    { value: "Global fund", display_value: "Global fund" },
                    { value: "Hybrid fund", display_value: "Hybrid fund" },
                    { value: "Hedge fund", display_value: "Hedge fund" },
                    { value: "ETFs", display_value: "ETFs" },
                    { value: "Open-end fund", display_value: "Open-end fund" },
                    { value: "Investment trust", display_value: "Investment trust" },
                    { value: "Stock", display_value: "Stock" },
                    { value: "Closed-end", display_value: "Closed-end" }
                ]}
            />

            <Input 
                label={"Nature/Purpose"}
                name={"uboNature"}
                value={formData.uboNature}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            

            <Input
                label={"Name of Fund Manager"}
                name={"uboFundManager"}
                value={formData.uboFundManager}
                onChange={onChange}
                disabled={isReadOnly}
                isReport={isReport}
            />

            <RadioGroup 
                label={"Is the fund manager regulated ?"}
                name={"uboIsRegulatedFundManager"}
                value={formData.uboIsRegulatedFundManager}
                onChange={onChange}
                disabled={isReadOnly}
                options={yesNoOption}
                isReport={isReport}
            />

            {formData.uboIsRegulatedFundManager === "Yes" && (
                <>
                    <SelectRegulatoryBody 
                    label={"Name of Regulatory Body"}
                    name={"uboRegulatoryBody"}
                    value={formData.uboRegulatoryBody}
                    onChange={onChange}
                    disabled={isReadOnly}
                    country={formData.uboCountry}
                    isReport={isReport}
                />

                    <Input 
                        label={"Enter Regulatory Reference Number"}
                        name={"uboRegulatoryReferenceNumber"}
                        value={formData.uboRegulatoryReferenceNumber}
                        onChange={onChange}  
                        disabled={isReadOnly}
                        isReport={isReport}
                    />
                </>
            )}

            <RadioGroup 
                label={"Are there any +25% investors/ ultimate shareholders in the fund ?"}
                name={"uboAreThereAnyInvestors"}
                value={formData.uboAreThereAnyInvestors}
                onChange={onChange}
                disabled={isReadOnly}
                options={yesNoOption}
                isReport={isReport}
            />

        </>
    );
});